import { Tooltip } from "react-tooltip"
import "react-tooltip/dist/react-tooltip.css"
import { useContext } from "react"

import Stack from "@p-ban/common/src/components/layout/Stack"

import type { ManufactureCourse } from "../../../constant/manufactureCourse"
import MANUFACTURE_COURSE from "../../../constant/manufactureCourse"
import type { ManufactureResult as ManufactureResultType, ResultsPerCourse } from "../../../types/parsedResult"
import { RadioGroup, RadioGroupItem } from "../../../../../shadcn/RadioGroup"
import CourseBox from "../../components/1Click/result/CourseBox"
import ServiceResult from "./ServiceResult"
import デリバリーゼロ from "./options/デリバリーゼロ/デリバリーゼロ"

import 製造 from "./manufacture.png"
import OneClickEstimateContext from "../../OneClickEstimateContext"

type Props = {
  isRigid: boolean
  hasMount: boolean
  manufacture: ResultsPerCourse<ManufactureResultType>
  selectedManufactureCourse: ManufactureCourse
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const ManufactureResult = ({ isRigid, hasMount, manufacture, selectedManufactureCourse, onChange }: Props) => {
  const { deliveryZeroFlg } = useContext(OneClickEstimateContext)
  const isShow = isRigid && !hasMount

  const handleValueChange = (value: string) => {
    onChange({ target: { value } } as React.ChangeEvent<HTMLInputElement>)
  }

  return (
    <ServiceResult src={製造} title="基板製造サービス" subTitle="（コースを選択）">
      <RadioGroup value={selectedManufactureCourse.value} onValueChange={handleValueChange}>
        <Stack direction="column" spacing={5}>
          {Object.values(MANUFACTURE_COURSE).map((manufactureCourse) => {
            const { key, name: displayName, value, option } = manufactureCourse
            const { errors } = manufacture[key]
            const checked = selectedManufactureCourse.value === value
            // TODO: オプションが増えた際に適切な場所で制御できるように要改善
            const shouldChangeBgColor = {
              ウルトラクイック: {
                shouldBgColorChange:
                  isShow &&
                  deliveryZeroFlg &&
                  manufactureCourse === MANUFACTURE_COURSE.ultraQuick &&
                  selectedManufactureCourse === MANUFACTURE_COURSE.ultraQuick,
              },
              スーパークイック: {
                shouldBgColorChange: false,
              },
              クイック: {
                shouldBgColorChange: false,
              },
              ノーマル: {
                shouldBgColorChange: false,
              },
              量産: {
                shouldBgColorChange: false,
              },
            }[displayName].shouldBgColorChange

            return (
              <div key={key} className={`${shouldChangeBgColor ? "bg-[#EDF5FD]" : ""}`}>
                <label id={displayName} className="flex cursor-pointer items-center gap-2">
                  <div>
                    <RadioGroupItem value={value} />
                  </div>
                  <div className="flex-1 font-bold">
                    <CourseBox
                      name={displayName}
                      days={manufacture[key].days}
                      amount={manufacture[key].amount}
                      checked={checked}
                      isRadioMode
                    >
                      {/* TODO : デリバリーゼロは表示非表示をisShowで切り替える作りだが、呼び出し元でもisShowを用いてコンポーネント事態の表示を切り替えている。
                                 これは、子要素の有無と、レンダリングした結果として表示非表示は別の概念であるためである。
                                 とはいえ、このような作りは直感的ではないため、将来的に改善を検討する。
                       */}
                      {option && isShow && (
                        <デリバリーゼロ
                          isShow={isShow}
                          manufactureCourse={manufactureCourse}
                          selectedManufactureCourse={selectedManufactureCourse}
                        />
                      )}
                    </CourseBox>
                  </div>
                </label>
                {errors && (
                  <Tooltip anchorId={displayName} place="left" positionStrategy="fixed">
                    {errors.map((error, i) => (
                      <p key={i} className="max-w-[700px]">
                        {error}
                      </p>
                    ))}
                  </Tooltip>
                )}
              </div>
            )
          })}
        </Stack>
      </RadioGroup>
    </ServiceResult>
  )
}

export default ManufactureResult
